import React from 'react';
import { withStyles } from "@mui/styles";

const styles = {
  root: {
    fontWeight: 500,
    fontSize: '0.85em',
    opacity:'0.8',
    textTransform:'uppercase'
  },
};

function Keyword({children, className='', classes, ...divProps}) {
  return <span className={`${classes.root} ${className}`} {...divProps}>{children}</span>;
};

export default withStyles(styles)(Keyword);
